import { FC } from "react";

import { FormDialog } from "@dzambalaorg/mui-dialog-form";
import { SelectInput, TextInput } from "@dzambalaorg/mui-inputs-core";
import { RichTextEditor } from "@dzambalaorg/mui-inputs-draft";
import { PageStatus } from "@framework/types";
import type { IPage } from "@framework/types";

import { validationSchema } from "./validation";

export interface IEditPageDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: (values: Partial<IPage>, formikBag: any) => Promise<void>;
  initialValues: IPage;
}

export const PageEditDialog: FC<IEditPageDialogProps> = props => {
  const { initialValues, ...rest } = props;

  const { id, title, description, slug, pageStatus } = initialValues;
  const fixedValues = {
    id,
    title,
    description,
    slug,
    pageStatus,
  };

  const message = id ? "dialogs.edit" : "dialogs.create";

  return (
    <FormDialog
      initialValues={fixedValues}
      validationSchema={validationSchema}
      message={message}
      testId="PageEditForm"
      {...rest}
    >
      <TextInput name="slug" />
      <TextInput name="title" />
      <RichTextEditor name="description" customControls={["media", "link"]} />
      {id ? <SelectInput name="pageStatus" options={PageStatus} /> : null}
    </FormDialog>
  );
};
